// extracted by mini-css-extract-plugin
export var quantityInput = "_mh-0";